import { datadogRum } from '@datadog/browser-rum';

export const initDatadog = () => {
    datadogRum.init({
        applicationId: MA.Config.DD_APPLICATION_ID,
        clientToken: MA.Config.DD_CLIENT_TOKEN,
        site: 'datadoghq.eu',
        service: 'ma_www_flask',
        version: MA.Config.DD_VERSION,
        env: MA.Config.DD_ENV,
        sessionSampleRate: 5,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask',
    });

    datadogRum.startSessionReplayRecording();
};
